import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 radius-7 bg-white welcome-support-desk-box" }
const _hoisted_2 = { class: "card-body ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 letter-spacing" }
const _hoisted_3 = { class: "row align-items-center mt-20 mb-20" }
const _hoisted_4 = { class: "col-xxl-6" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "fw-semibold mb-8 text-white" }
const _hoisted_7 = { class: "fw-bold text-black" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "fs-md-15 fs-lg-16" }, " Abaixo estão as métricas totais de todo o periodo utilizado ", -1)
const _hoisted_9 = { class: "row list justify-content-center width-card-totals col-12 flex-column flex-sm-column flex-row flex-xl-row flex-xxl-row flex-xxxl-row" }
const _hoisted_10 = { class: "col-lg-3 col-6 col-sm-3" }
const _hoisted_11 = { class: "p-15 mt-15 bg-18dcff radius-7" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase" }, "Uploads com sucesso", -1)
const _hoisted_13 = { class: "mb-0 fw-black text-success" }
const _hoisted_14 = { class: "col-lg-3 col-6 col-sm-3" }
const _hoisted_15 = { class: "p-15 mt-15 bg-f2f1f9 radius-7" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase" }, "Uploads com erro", -1)
const _hoisted_17 = { class: "mb-0 fw-black text-danger" }
const _hoisted_18 = { class: "col-lg-3 col-6 col-sm-3" }
const _hoisted_19 = { class: "p-15 mt-15 bg-ecf3f2 radius-7" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase" }, "Tempo total de gravação", -1)
const _hoisted_21 = { class: "mb-0 fw-black text-primary" }
const _hoisted_22 = { class: "col-lg-3 col-6 col-sm-3" }
const _hoisted_23 = { class: "p-15 mt-15 bg-faf7f7 radius-7" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-6 fw-medium text-black-emphasis fs-13 text-uppercase" }, "Tamanho total de gravação", -1)
const _hoisted_25 = { class: "mb-0 fw-black text-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getConfigurations.name), 1)
            ]),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.getMetricsTotals.total_success), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.getMetricsTotals.total_error), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("h4", _hoisted_21, _toDisplayString(_ctx.convertTime(_ctx.getMetricsTotals.total_time)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("h4", _hoisted_25, _toDisplayString((_ctx.getMetricsTotals.total_size / (1024 * 1024)).toFixed(2) + " MB"), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}